import moment from 'moment';
import { ExportTableApi } from '../../api';
import { saveAs } from 'file-saver';
import { effectifValue, getH2sDataColor } from './tableHelper';

export const hydroDataFormated = (pData: any[]) => {
  let dataFormated: any[] = [];
  pData.forEach((data) => {
    const hydroCommune = window.sessionStorage.getItem('hydro_commune');
    const hydroType = window.sessionStorage.getItem('hydro_type');
    const hydroNature = window.sessionStorage.getItem('hydro_nature');

    const communeBc = hydroCommune ? JSON.parse(hydroCommune).name : 'Toutes les communes';
    const type = hydroType ? JSON.parse(hydroType).name : 'Tous les types';
    const nature = hydroNature ? JSON.parse(hydroNature).name : 'Toutes les natures';

    dataFormated.push({
      synthese: data.label,
      effectif: data.effectif,
      communeBc: communeBc !== '' ? communeBc : 'Toutes les communes',
      type: type !== '' ? type : 'Tous les types',
      nature: nature !== '' ? nature : 'Toutes les natures',
    });
  });
  return dataFormated;
};

export const getPropertyValueContainingString = (obj: any, searchString: string) => {
  const propertyName = Object.keys(obj).find(key => key.includes(searchString));
  return propertyName ? obj[propertyName] : null;
}

export const strNoAccent = (chain: string) => {
  // this doesn't work anymore
  // return chain.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  return chain.split("'").join(' ');
}

// prepare body for request hence type of module
export const prepareDataToSend = (pData: any[], pType: string) => {
  let arrayToSend: any = [];
  pData.forEach((line) => {
    if (pType === 'do') {
      arrayToSend.push({
        commune: line.Commune === null ? 'Non disponible' : line.Commune,
        name: strNoAccent(line.Description),
        type: line.ModelCode,
        categColor: line.Color === null ? 'Non disponible' : line.Color,
      });
    } else if (pType === 'pr') {
      arrayToSend.push({
        commune: line.Commune === null ? 'Non disponible' : line.Commune,
        name: strNoAccent(line.Description),
        type: line.ModelCode,
        categColor: line.Color === null ? 'Non disponible' : line.Color,
        criticity: line.CriticityCode,
      });
    } else if (pType === 'h2s') {
      const h2sDataColor = getH2sDataColor();
      const h2sDataValue = getPropertyValueContainingString(line, 'Value');
      arrayToSend.push({
        commune: line.Commune === null ? 'Non disponible' : line.Commune,
        name: strNoAccent(line.Description),
        type: line.ModelCode,
        categColor: h2sDataColor === null ? 'Non disponible' : line[h2sDataColor],
        value: String(h2sDataValue === null ? 'Non disponible' : h2sDataValue),
      });
    } else if (pType === 'ecp') {
      arrayToSend.push({
        commune: line.Commune === null ? 'Non disponible' : line.Commune,
        label: line.collectionPoolLabel,
        avalPoint: line.Code,
        color: line.Color === null ? 'NOIR' : line.Color,
      });
    } else if (pType === 'indus') {
      arrayToSend.push({
        commune: line.City === null ? 'Non disponible' : line.City,
        communeCollectionPool: line.communeBc,
        establishment: line.Name === null ? 'Non disponible' : line.Name,
        mainActivity: line.ActivityLabel,
        domesticAssimilated:
          line.WarsmannNote === null
            ? 'Non disponible'
            : line.WarsmannNote === 1 ? 'Oui' : 'Non',
        section: line.SectionLabel,
        globalRank: String(line.Global_Note),
        employeeCount: effectifValue(line.SalariedWorkforceSlice),
        nafRank:
          line.NAF_Note === null ? 'Non disponible' : String(line.NAF_Note),
        rsdeRank:
          line.RSDE_Note === null ? 'Non disponible' : String(line.RSDE_Note),
      });
    } else if (pType === 'hydro') {
      arrayToSend.push({
        communeCollectionPool: line.communeBc,
        interventionType: line.type,
        interventionNature: line.nature,
        synthesis: line.synthese,
        effective: String(line.effectif),
      });
    } else if (pType === 'pluie') {
      arrayToSend.push({
        commune: line.Commune === null ? 'Non disponible' : line.Commune,
        name: strNoAccent(line.Description),
        type: line.ModelCode,
        volume: line.Volume === null ? 'Non disponible' : String(line.Volume),
        pluie: line.Mesure === null ? 'Non disponible' : String(line.Mesure),
        categColor: line.Color === null ? 'Non disponible' : line.Color,
      });
    } else if (pType === 'h2s-detail') {
      arrayToSend.push({
        date: line.date === null ? 'Non disponible' : line.date,
        boonAndLister:
          line.boonAndLister === null ? 'Non disponible' : String(line.boonAndLister),
        canaSojourn:
          line.canaSojourn === null ? 'Non disponible' : String(line.canaSojourn),
        prSojourn: line.prSojourn === null ? 'Non disponible' : String(line.prSojourn),
        selfCleaning: line.selfCleaning === null ? 'Non disponible' : String(line.selfCleaning),
      });
    } else if (pType === 'CollectionPool') {
      arrayToSend.push({
        collectionPoolName:
          line.collectionPoolName === null
            ? 'Non disponible'
            : strNoAccent(line.collectionPoolName).replace(/\(/g, '').replace(/\)/g, '').replace(/\d/g, ''),
        collectionPoolAvalPoint:
          line.collectionPoolAvalPoint === null
            ? 'Non disponible'
            : strNoAccent(line.collectionPoolAvalPoint),
        dotpColor:
          line.dotpColor === null ? 'Non disponible' : String(line.dotpColor),
        prmrColor:
          line.prmrColor === null ? 'Non disponible' : String(line.prmrColor),
        ecpColor:
          line.ecpColor === null ? 'Non disponible' : String(line.ecpColor),
        h2SColor:
          line.h2SColor === null ? 'Non disponible' : String(line.h2SColor),
        indusColor:
          line.indusColor === null
            ? 'Non disponible'
            : String(line.indusColor),
        hydroColor:
          line.hydroColor === null
            ? 'Non disponible'
            : String(line.hydroColor),
        milieuColor:
          line.milieuColor === null
            ? 'Non disponible'
            : String(line.milieuColor),
        pluieColor:
          line.pluieColor === null
            ? 'Non disponible'
            : String(line.pluieColor),
      });
    } else if (pType === 'admin-users') {
      arrayToSend.push({
        id: line.id === null ? 'Non disponible' : line.id,
        username: line.login === null ? 'Non disponible' : line.login,
        firstName:
          line.firstName === null ? 'Non disponible' : String(line.firstName),
        lastName:
          line.lastName === null ? 'Non disponible' : String(line.lastName),
        role: line.role === null ? 'Non disponible' : String(line.role),
        email: line.email === null ? 'Non disponible' : String(line.email),
        enabled: line.enabled,
        emailVerified:
          line.emailVerified,
      });
    } else {
      // milieu
      arrayToSend.push({
        commune: line.Commune === null ? 'Non disponible' : line.Commune,
        name: strNoAccent(line.Description),
        type: line.ModelCode,
      });
    }
  });
  return arrayToSend;
};

export const defineTypeOfCsvName = (pType: string) => {
  return pType === 'h2s' ? window.sessionStorage.getItem('h2s_indicator') || 'h2s' : pType;
};

// fetch to get csv
export const requestToGetCsv = async (
  pBody: any,
  pType: string,
  pContractLabel: string,
  pExtendeUrl: string
) => {
  let response;
  if (
    pType === 'indus' ||
    pType === 'hydro' ||
    pType === 'ecp'
  ) {
    try {
      response = await ExportTableApi.exportTableList(pBody, pExtendeUrl);
    } catch (e) {
      console.error('Failed to request', e);
    }
  } else if (pType === 'pluie') {
    try {
      response = await ExportTableApi.exportTableListPluie(pBody);
    } catch (e) {
      console.error('Failed to request', e);
    }
  } else if (pType === 'CollectionPool') {
    try {
      response = await ExportTableApi.exportTableCollectionPoolSummary(
        pBody
      );
    } catch (e) {
      console.error('Failed to request', e);
    }
  } else if (pType === 'h2s-detail') {
    try {
      response = await ExportTableApi.exportTableH2sDetail(pBody);
    } catch (e) {
      console.error('Failed to request', e);
    }
  } else {
    try {
      response = await ExportTableApi.exportTable(pBody);
    } catch (e) {
      console.error('Failed to request', e);
    }
  }

  const filename =
    'export-' +
    defineTypeOfCsvName(pType) +
    '-' +
    (pType !== 'admin-users' ? pContractLabel + '-' : '') +
    moment().utc().format('YYYY-MM-DD') +
    '.csv';
  createBlob(response.data, filename);
};

// specify end point
export const defineExtendedUrl = (pType: string) => {
  let extendedUrl = '';
  if (pType === 'ecp') {
    extendedUrl = '/ecp';
  } else if (pType === 'indus') {
    extendedUrl = '/indus';
  } else if (pType === 'hydro') {
    extendedUrl = '/hydro';
  } else if (pType === 'milieu') {
    extendedUrl = '/milieu';
  }
  return extendedUrl;
};

// create a blob for csv file
export const createBlob = (pData: any, pFilename: string) => {
  const blob = new Blob(['\ufeff' + pData], {
    type: 'data:text/csv;charset=utf-8,',
  });
  saveAs(blob, pFilename);
};
